module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobileFaceVerification"
  }, [_c('van-nav-bar', {
    staticClass: "userNavBar",
    attrs: {
      "title": "实名认证",
      "left-arrow": ""
    },
    on: {
      "click-left": _vm.onClickLeft
    },
    scopedSlots: _vm._u([{
      key: "left",
      fn: function() {
        return [_c('van-icon', {
          attrs: {
            "name": "../../../static/images/mobile/back.png",
            "size": "18"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "faceTitle"
  }, [_vm._v("请确保脸部清晰光线充足")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "startPic"
  }, [_c('van-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.baiDuFace()
      }
    }
  }, [_vm._v("开始拍照")])], 1), _vm._v(" "), _c('div', {
    staticClass: "standard",
    on: {
      "click": _vm.showPopup
    }
  }, [_vm._v("查看规范")]), _vm._v(" "), _c('van-popup', {
    staticClass: "standardPic",
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "standardPic-title"
  }, [_vm._v("人像拍照规范")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../static/images/mobile/standard.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('van-button', {
    attrs: {
      "plain": "",
      "type": "primary"
    },
    on: {
      "click": _vm.hidePopup
    }
  }, [_vm._v("我知道了")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "facepic"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../static/images/mobile/faceintroduce.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-05e9fa58"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/MobileFaceVerification.vue
// module id = 1126
// module chunks = 41